export default {
  preCheckIn: {
    langName: 'Português',
    steps: {
      reserve: 'Reserva',
      guests: 'Hóspedes',
      confirmation: 'Confirmação',
    },
    step1: {
      title: 'Pré Check-in Online',
      subtitle: 'Informe o número da sua reserva para iniciar o pré check-in.',
      reserveNumber: 'Número da Reserva',
      continue: 'Continuar',
      errorEmpty: 'Informe o número da reserva',
      errorNotFound: 'Reserva não encontrada ou não confirmada.',
    },
    step2: {
      reservationLabel: 'Reserva',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      alreadyDoneTitle: 'Pré Check-in já realizado!',
      alreadyDoneBody: 'Os dados dos hóspedes desta reserva já foram registrados. Você pode atualizar as informações abaixo se necessário.',
      progress: 'Pré-check-in em andamento: {completed} de {total} hóspedes concluíram.',
      hotelRules: 'Regras do Hotel',
      mainGuestChip: 'Principal — obrigatório para NF-e',
      additionalAdultChip: 'Adulto adicional',
      childChip: 'Criança',
      addressSection: 'Endereço',
      contactSection: 'Contato',
      fnrhSection: 'Dados FNRH',
      back: 'Voltar',
      previous: '← Anterior',
      next: 'Próximo →',
      confirm: 'Confirmar Pré Check-in',
      saveGuest: 'Salvar este hóspede',
      updateGuest: 'Atualizar este hóspede',
      guestConfirmedTitle: 'Dados confirmados',
      requiredError: 'Preencha todos os campos obrigatórios.',
      fieldRequired: '{field} é obrigatório',
      fields: {
        typeDoc: 'Tipo de documento',
        cpf: 'CPF',
        cpfOptional: 'CPF (opcional)',
        docNumber: 'Número do documento',
        name: 'Nome completo',
        firstName: 'Nome',
        lastName: 'Sobrenome',
        birthDate: 'Data de nascimento',
        gender: 'Sexo',
        nationality: 'Nacionalidade',
        maritalStatus: 'Estado civil',
        profession: 'Profissão',
        originCity: 'Cidade de origem',
        issuingBody: 'Órgão expedidor',
        zipcode: 'CEP',
        zipcodePostal: 'CEP / Postal Code',
        address: 'Endereço',
        number: 'Número',
        complement: 'Complemento',
        neighborhood: 'Bairro',
        country: 'País',
        state: 'Estado',
        city: 'Cidade',
        email: 'E-mail',
        cellPhone: 'Celular',
        race: 'Raça/Cor',
        disability: 'Deficiência',
        disabilityDesc: 'Descrição da deficiência',
      },
    },
    step3: {
      title: 'Pré Check-in Realizado!',
      body: 'Os hóspedes foram vinculados à reserva #{id}. Na chegada ao hotel, o check-in será mais rápido pois os dados já estão registrados.',
      registeredGuests: 'Hóspedes registrados:',
      mainGuestLabel: 'Hóspede Principal',
    },
    guestLabel: {
      main: 'Principal',
      child: 'Criança {n}',
      adult: 'Adulto {n}',
    },
    genericSubmitError: 'Erro ao realizar pré check-in.',
    options: {
      gender: { M: 'Masculino', F: 'Feminino' },
      marital: {
        0: 'Solteiro(a)', 1: 'Casado(a)', 2: 'Divorciado(a)', 3: 'Viúvo(a)', 4: 'União Estável',
      },
      mainDocTypes: { 0: 'CPF', 1: 'Passaporte', 2: 'RNE' },
      typeDoc: {
        0: 'CPF', 1: 'RG', 2: 'CNH', 3: 'Passaporte', 4: 'RNE', 5: 'Certidão de Nascimento', 6: 'Outro',
      },
      race: {
        0: 'Branca', 1: 'Preta', 2: 'Parda', 3: 'Amarela', 4: 'Indígena', 5: 'Não Declarada',
      },
      disability: {
        0: 'Nenhuma', 1: 'Física', 2: 'Visual', 3: 'Auditiva', 4: 'Intelectual', 5: 'Múltipla',
      },
    },
  },
}
